import { rfqRequestQuoteProductListStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuoteProductList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(rfqRequestQuoteProductListStyles, {
    ...rfqRequestQuoteProductListStyles,
    lineCountWrapper: {
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            padding-bottom: 10px;
        `,
    },
});
